import {
  Button,
  Card,
  Carousel,
  Checkbox,
  Col,
  DatePicker,
  Flex,
  Form,
  Grid,
  Input,
  Popover,
  Row,
  Tabs,
  theme,
  Typography,
  Image,
  List,
  Rate,
} from "antd";
import React, { useState } from "react";
import slider1 from "assets/images/inner-slider-1.jpg";
import activate from "assets/images/activate.svg"; 
import map from "assets/images/map.svg";
import calendar from "assets/images/calendar.svg";
import adult from "assets/images/adult.svg";
import arrowDropDown from "assets/images/arrow-drop-down.svg";
import arrowFill from "assets/images/arrow-fill.svg"; 
import destinations from "assets/images/destinations.png";
import destinations2 from "assets/images/destinations2.jpg";
import destinations3 from "assets/images/destinations3.jpg";
import destinations4 from "assets/images/destinations4.jpg";
import destinations5 from "assets/images/destinations5.jpg";
import destinations6 from "assets/images/destinations6.jpg";
import destinations7 from "assets/images/destinations7.jpg";  
import choose1 from "assets/images/choose1.jpg";
import choose2 from "assets/images/choose2.jpg";
import choose3 from "assets/images/choose3.jpg";
import exclusive1 from "assets/images/exclusive1.jpg";
import exclusive2 from "assets/images/exclusive2.jpg";
import exclusive3 from "assets/images/exclusive3.jpg";
import exclusive4 from "assets/images/exclusive4.jpg";
import exclusive5 from "assets/images/exclusive5.jpg";
import choose1svg from "assets/images/choose1.svg";
import choose2svg from "assets/images/choose2.svg";
import choose3svg from "assets/images/choose3.svg";
import choose4svg from "assets/images/choose4.svg";
import choose5svg from "assets/images/choose5.svg";   
import "./activitiesComponent.scss";

const {Text } = Typography;

function ActivitiesComponent() {
  const screens = Grid.useBreakpoint();
  
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !screens.xs,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        arrows: false,
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    className: "custom-slider",
  }; 

  const exclusive = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: !screens.xs,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        arrows: false,
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    className: "custom-slider",
  };

  const [form] = Form.useForm();
  const variant = Form.useWatch("variant", form);
  type SizeType = Parameters<typeof Form>[0]["size"];
  const [componentSize, setComponentSize] = useState<SizeType | "default">(
    "default"
  );
 
  // Dummy flag data
  const flags = [
    { code: "us", name: "United States", icon: "🇺🇸" },
    { code: "fr", name: "France", icon: "🇫🇷" },
    { code: "in", name: "India", icon: "🇮🇳" },
  ];
  const [selectedFlag, setSelectedFlag] = useState(flags[0]); // Default flag

  // Handle flag selection
  const handleFlagSelect = (flag: any) => {
    setSelectedFlag(flag); // Update selected flag
    form.setFieldValue("flag", flag.code); // Update form value for "flag"
  };

  // Flag options displayed in the Popover
  const flagOptions = (
    <div style={{ width: 200 }}>
      <Row gutter={[8, 8]}>
        {flags.map((flag) => (
          <Col span={8} key={flag.name}>
            <div
              style={{
                cursor: "pointer",
                padding: 8,
                textAlign: "center",
                border: "1px solid #f0f0f0",
                borderRadius: 4,
              }}
              onClick={() => handleFlagSelect(flag)}
            >
              <span style={{ fontSize: 20 }}>{flag.icon}</span>
              <div style={{ fontSize: 12 }}>{flag.name}</div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );

  const onChange = (date: any, dateString: any) => {
    console.log(date, dateString);
  };

  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e: any) => {
    setInputValue(e.target.value);
  };

  const popoverContent = (
    <div>
      <p>This is a custom box!</p>
      <p>You can add any content here.</p>
    </div>
  );

  const [visible, setVisible] = useState(false); // State to control visibility

  const toggleVisibility = () => {
    setVisible(!visible); // Toggle the visibility state
  };

  const checkCity = (e: any) => {
    console.log(`checked = ${e.target.checked}`);
  };

  

  const items = [
    {
      key: "1",
      label: (
        <span>
          <img
            src={activate} // Replace with your file path
            alt="Activities"
            style={{ width: 16, height: 16, marginRight: 8 }}
          />
          Activities
        </span>
      ),
      children: (
        <>
          <Form
            layout="vertical"
            initialValues={{ variant: "filled", size: componentSize }}
            variant={variant || "filled"}
            form={form}
            size={"large"}
          >
            <Checkbox
              className="radio-type-danger-round mb-4"
              onChange={checkCity}
            >
              Dubai City
            </Checkbox>
            <Row gutter={[16, 16]} className="mt-3 mb-4">
              <Col xs={24} sm={24} md={24} lg={8}>
                <Form.Item
                  label=""
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your name!" },
                  ]}
                >
                  <Popover content={flagOptions} trigger="click">
                    <Input
                      prefix={<img src={map} />}
                      value={selectedFlag.name}
                    />
                  </Popover>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={5}>
                <Form.Item
                  label=""
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your name!" },
                  ]}
                >
                  <DatePicker
                    prefix={<img src={calendar} />}
                    className="w-100"
                    onChange={onChange}
                    suffixIcon={null}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={7}>
                <Form.Item
                  label=""
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your name!" },
                  ]}
                >
                  <Popover
                    content={popoverContent}
                    trigger="click"
                    placement="bottomLeft"
                  >
                    <Input
                      prefix={<img src={adult} />}
                      value={inputValue}
                      onChange={handleInputChange}
                      placeholder=""
                      suffix={<img src={arrowDropDown} />}
                    />
                  </Popover>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={4}>
                <Button
                  type="primary"
                  danger
                  htmlType="submit"
                  className="w-100"
                  href="#/products"
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
          <Form
            layout="vertical"
            initialValues={{ variant: "filled", size: componentSize }}
            variant={variant || "filled"}
            form={form}
          >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24} lg={5}>
                <Text>
                  <div onClick={toggleVisibility}>
                    <b>Set Your Preference</b> <img src={arrowFill} alt="" />{" "}
                  </div>
                </Text>
              </Col>
              {visible && (
                <>
                  <Col xs={24} sm={24} md={24} lg={5}>
                    <Popover content={flagOptions} trigger="click">
                      <Input
                        value={"Destination"}
                        suffix={<img src={arrowDropDown} />}
                      />
                    </Popover>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5}>
                    <Popover content={flagOptions} trigger="click">
                      <Input
                        value={"0% Markup"}
                        suffix={<img src={arrowDropDown} />}
                      />
                    </Popover>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5}>
                    <Popover content={flagOptions} trigger="click">
                      <Input
                        value={"AED Currency"}
                        suffix={<img src={arrowDropDown} />}
                      />
                    </Popover>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={4}>
                    <Button
                      type="primary"
                      danger
                      htmlType="submit"
                      className="w-100"
                    >
                      Save
                    </Button>
                  </Col>
                </>
              )}
            </Row>
          </Form>
        </>
      ),
    }
  ];
 
  return (
    <>
      <Carousel {...settings} className="top-header-slider">
        <div>
          <div
            className="coverImage"
            style={{ backgroundImage: `url(${slider1})` }}
          >
            <div className="container position-relative">
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Typography.Title level={2} className="mb-0">
                    The Best Christmas Markets
                  </Typography.Title>
                  <Typography.Title
                    level={1}
                    className="mt-0 mb-0"
                  >
                    Festive Events and Winter Activities in Dubai
                  </Typography.Title>
                  <Button size="large" className="px-5 mt-5">
                    See More
                  </Button>
                </Col>
              </Row>
            </div>
          </div>

          {/* <Image src={slider1} preview={false} /> */}
        </div>

        <div>
          <div
            className="coverImage"
            style={{ backgroundImage: `url(${slider1})` }}
          >
            <div className="container position-relative">
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Typography.Title level={2} className="mb-2">
                    The Best Christmas Markets
                  </Typography.Title>
                  <Typography.Title
                    level={1} 
                    className="mt-0 mb-0"
                  >
                    Festive Events and Winter Activities in Dubai
                  </Typography.Title>

                  {/* <Typography.Title level={1} className="mt-0 mb-0">
                    Why Book With Us?
                  </Typography.Title> */}
                </Col>
              </Row>
            </div>
          </div>

          {/* <Image src={slider1} preview={false} /> */}
        </div>
      </Carousel>

      <div className="container">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Tabs
              defaultActiveKey="1"
              items={items}
              type="card"
              className="efficient-tabs"
            />
          </Col>
        </Row>
      </div>
      <div className="container">
        <Row gutter={[16, 16]} className="mt-100 mb-4">
          <Col span={24}>
            <Typography.Title level={2} className="mt-0 mb-0">
              Explore new
            </Typography.Title>
            <Typography.Title level={1} className="mb-0 mt-0">
              Most Visited &nbsp;
              <Text type="danger" className="header-font-title">
                Destinations
              </Text>
            </Typography.Title>
          </Col>
        </Row>
        <div className="carousel-container">
          <Flex gap="middle" align="center" className="destination-wrapper">
            <div className="carousel-slide single-image">
              <div className="image-view">
                <Typography.Title
                  level={4}
                  className="position-absolute mb-0 mt-0"
                >
                  Abu Dhabi
                </Typography.Title>
                <div className="overlay"></div>
                <Image preview={false} width={"100%"} src={destinations} />
              </div>
            </div>
            <div className="carousel-slide double-image">
              <div className="image-view image-half image-small">
                <Typography.Title
                  level={4}
                  className="position-absolute mb-0 mt-0"
                >
                 Dubai
                </Typography.Title>
                <div className="overlay"></div>
                <Image preview={false} width={"100%"} src={destinations2} />
              </div>
              <div className="image-view image-half image-large">
                <Typography.Title
                  level={4}
                  className="position-absolute mb-0 mt-0"
                >
                  Jeddah
                </Typography.Title>
                <div className="overlay"></div>
                <Image preview={false} width={"100%"} src={destinations3} />
              </div>
            </div>
            <div className="carousel-slide double-image">
              <div className="image-view">
                <Typography.Title
                  level={4}
                  className="position-absolute mb-0 mt-0"
                >
                  Malaysia
                </Typography.Title>
                <div className="overlay"></div>
                <Image preview={false} width={"100%"} src={destinations4} />
              </div>

              <div className="image-view">
                <Typography.Title
                  level={4}
                  className="position-absolute mb-0 mt-0"
                >
                  Riyadh
                </Typography.Title>
                <div className="overlay"></div>
                <Image preview={false} width={"100%"} src={destinations5} />
              </div>
            </div>

            <div className="carousel-slide double-image">
              <div className="image-view">
                <Typography.Title
                  level={4}
                  className="position-absolute mb-0 mt-0"
                >
                 Singapore
                </Typography.Title>
                <div className="overlay"></div>
                <Image preview={false} width={"100%"} src={destinations6} />
              </div>

              <div className="image-view">
                <Typography.Title
                  level={4}
                  className="position-absolute mb-0 mt-0"
                >
                  Jeddah
                </Typography.Title>
                <div className="overlay"></div>
                <Image preview={false} width={"100%"} src={destinations7} />
              </div>
            </div>
          </Flex>
        </div>
      </div>

      <div className="container">
        <Row gutter={[32, 48]} justify="space-between" className="mt-100">
          <Col xs={24} sm={24} md={12} lg={11} className="position-relative choose-wrapper">
            <Card
              className="border-radius-20 chooseUs-one"
              cover={
                <>
                  <span></span> <img alt="example" src={choose1} />
                </>
              }
            ></Card>
            <Card
              className="border-radius-20 chooseUs-two"
              cover={
                <>
                  <span></span> <img alt="example" src={choose2} />
                </>
              }
            ></Card>
            <Card
                
              className="border-radius-20 chooseUs-three"
              cover={
                <>
                  <span></span> <img alt="example" src={choose3} />
                </>
              }
            ></Card>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12}>
            <Typography.Title
              level={2}
              
              className="mt-0 mb-0"
            >
              Why Choose
            </Typography.Title>

            <Typography.Title level={1} className="mt-0 mb-0">
              Efficient
              <Text type="danger" className="header-font-title">
                Tourism
              </Text>
            </Typography.Title>

            <List itemLayout="horizontal" className="list-view">
              <List.Item>
                <List.Item.Meta
                  avatar={<img src={choose5svg} />}
                  title={
                    <Typography.Text>{"Best Price Guarantee"}</Typography.Text>
                  }
                  description="Agent who fulfills the criteria can register as an Agent. wherein the agent can login and access the services he wants to book."
                />
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  avatar={<img src={choose4svg} />}
                  title={
                    <Typography.Text>
                      {"24X7 Live Chat Support"}
                    </Typography.Text>
                  }
                  description="Best Price Guarantee promises our esteemed clients that they will not only be faultlessly served with the Destination Management services"
                />
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  avatar={<img src={choose3svg} />}
                  title={
                    <Typography.Text>
                      {"Easy Online Transaction"}
                    </Typography.Text>
                  }
                  description="Reliability and safety of our customers' personal data are top of mind at Rayna Tours, and that's why our sophisticated online portal is thoroughly"
                />
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  avatar={<img src={choose2svg} />}
                  title={
                    <Typography.Text>
                      {"Secure Online Transaction"}
                    </Typography.Text>
                  }
                  description="Our online payment system is secure! In fact it encrypts your payment information to protect you against fraud and unauthorized transactions."
                />
              </List.Item>
              <List.Item>
                <List.Item.Meta
                  avatar={<img src={choose1svg} />}
                  title={
                    <Typography.Text>
                      {"Guest Reviews & Rating"}
                    </Typography.Text>
                  }
                  description="Our online payment system is secure! In fact it encrypts your payment information to protect you against fraud and unauthorized transactions."
                />
              </List.Item>
            </List>
          </Col>
        </Row>
      </div>

      <div className="container">
        <Row gutter={[32, 48]} justify="space-between" className="mt-100 mb-4">
          <Col xs={24} sm={24} md={24} lg={24}>
            <Typography.Title
              level={2} 
              className="mt-0 mb-0"
            >
              Limited Opportunity
            </Typography.Title>

            <Typography.Title  level={1} className="mt-0 mb-0">
              Exclusive&nbsp;
              <Text type="danger" className="header-font-title">
                Efficient Window
              </Text>
            </Typography.Title>
          </Col>
        </Row>
      </div>

      <div className="container">
        <Carousel
          {...exclusive}
          dotPosition="bottom"
          dots={false}
          className="product-slider"
        >
          <div className="exclusiveSlider">
            <div className="textbox">
              <Typography.Title level={5} className="mt-0 mb-0 text-container">
                AYA Universe Dubai AYA Universe Dubai
              </Typography.Title>
              <Flex
                gap="middle"
                align="center"
                justify="space-between"
                className="mt-4 mb-1"
              >
                <Text className="font-14">108 Reviews</Text>
                <Text className="font-14">Per Person from</Text>
              </Flex>

              <Flex
                gap="middle"
                align="center"
                justify="space-between"
                className="mt-0 mb-0"
              >
                <Rate allowHalf defaultValue={5} className="white-rate" />
                <Typography.Title level={5} className="mt-0 mb-0">
                  AED 95.50
                </Typography.Title>
              </Flex>
            </div>

            <div className="overlay"></div>
            <div
              className="exclusiveCard"
              style={{ backgroundImage: `url(${exclusive5})` }}
            ></div>
          </div>
          <div className="exclusiveSlider">
            <div className="textbox">
              <Typography.Title level={5} className="mt-0 mb-0">
                AYA Universe Dubai
              </Typography.Title>
              <Flex
                gap="middle"
                align="center"
                justify="space-between"
                className="mt-4 mb-1"
              >
                <Text className="font-14">108 Reviews</Text>
                <Text className="font-14">Per Person from</Text>
              </Flex>

              <Flex
                gap="middle"
                align="center"
                justify="space-between"
                className="mt-0 mb-0"
              >
                <Rate allowHalf defaultValue={2.5} className="white-rate" />
                <Typography.Title level={5} className="mt-0 mb-0">
                  AED 95.50
                </Typography.Title>
              </Flex>
            </div>

            <div className="overlay"></div>
            <div
              className="exclusiveCard"
              style={{ backgroundImage: `url(${exclusive2})` }}
            ></div>
          </div>
          <div className="exclusiveSlider">
            <div className="textbox">
              <Typography.Title level={5} className="mt-0 mb-0">
                AYA Universe Dubai
              </Typography.Title>
              <Flex
                gap="middle"
                align="center"
                justify="space-between"
                className="mt-4 mb-1"
              >
                <Text className="font-14">108 Reviews</Text>
                <Text className="font-14">Per Person from</Text>
              </Flex>

              <Flex
                gap="middle"
                align="center"
                justify="space-between"
                className="mt-0 mb-0"
              >
                <Rate allowHalf defaultValue={5} className="white-rate" />
                <Typography.Title level={5} className="mt-0 mb-0">
                  AED 95.50
                </Typography.Title>
              </Flex>
            </div>

            <div className="overlay"></div>
            <div
              className="exclusiveCard"
              style={{ backgroundImage: `url(${exclusive3})` }}
            ></div>
          </div>
          <div className="exclusiveSlider">
            <div className="textbox">
              <Typography.Title level={5} className="mt-0 mb-0">
                AYA Universe Dubai
              </Typography.Title>
              <Flex
                gap="middle"
                align="center"
                justify="space-between"
                className="mt-4 mb-1"
              >
                <Text className="font-14">108 Reviews</Text>
                <Text className="font-14">Per Person from</Text>
              </Flex>

              <Flex
                gap="middle"
                align="center"
                justify="space-between"
                className="mt-0 mb-0"
              >
                <Rate allowHalf defaultValue={5} className="white-rate" />
                <Typography.Title level={5} className="mt-0 mb-0">
                  AED 95.50
                </Typography.Title>
              </Flex>
            </div>

            <div className="overlay"></div>
            <div
              className="exclusiveCard"
              style={{ backgroundImage: `url(${exclusive4})` }}
            ></div>
          </div>
          <div className="exclusiveSlider">
            <div className="textbox">
              <Typography.Title level={5} className="mt-0 mb-0">
                AYA Universe Dubai
              </Typography.Title>
              <Flex
                gap="middle"
                align="center"
                justify="space-between"
                className="mt-4 mb-1"
              >
                <Text className="font-14">108 Reviews</Text>
                <Text className="font-14">Per Person from</Text>
              </Flex>

              <Flex
                gap="middle"
                align="center"
                justify="space-between"
                className="mt-0 mb-0"
              >
                <Rate allowHalf defaultValue={5} className="white-rate" />
                <Typography.Title level={5} className="mt-0 mb-0">
                  AED 95.50
                </Typography.Title>
              </Flex>
            </div>

            <div className="overlay"></div>
            <div
              className="exclusiveCard"
              style={{ backgroundImage: `url(${exclusive1})` }}
            ></div>
          </div>
        </Carousel>
      </div>
    </>
  );
}

export default ActivitiesComponent;
